import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { UserCards, Users } from "../../../../Constants/Constants";
import AllCards from "./AllCards";

const UsersCardsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={UserCards} parent={Users} />
      <Container fluid>
        <Row>
          <AllCards />
        </Row>
      </Container>
    </>
  );
};

export default UsersCardsContainer;
